import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import { IDialogType } from '../constants/detention'

interface IReviewActionProps {
  onClick: Function
  openDialog: Function
  value: IDialogType
  className: string
  name: string
}

export const ReviewAction = memo<IReviewActionProps>(
  ({ className, name, onClick, openDialog, value }) => {
    const dispatch = useDispatch()
    const handleClick = (e: { preventDefault: () => void }) => {
      e.preventDefault()
      onClick(value)
      dispatch(openDialog())
    }
    return (
      <button className={className} onClick={handleClick} data-test={`${name}-button`}>
        {name}
      </button>
    )
  }
)
